import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { environment } from '@env';
import { HttpModule, PipeModule, ScriptLoaderModule, TranslateModule } from '@interticket/core';
import { CartGuard } from '@shared/guards/cart.guard';
import { ErrorLoggerService, ErrorService } from 'common';
import { ICardSource } from './interfaces/card/card-source.interface';
import { ICartSource } from './interfaces/cart/cart-source.interface';
import { ICustomerSource } from './interfaces/customer/customer-source.interface';
import { IEventsSource } from './interfaces/event/events-source.interface';
import { IIamSource } from './interfaces/iam/iam-source.interface';
import { IMediaSource } from './interfaces/media/media-source.interface';
import { IPartnerSource } from './interfaces/partner/partner-source.interface';
import { IPaymentSource } from './interfaces/payment/payment-source.interface';
import { IVenueSource } from './interfaces/venue/venue-source.interface';
import { AuthService } from './services/auth/auth.service';
import { CardSourceMockService } from './services/card/card-source-mock.service';
import { CardSourceService } from './services/card/card-source.service';
import { CardService } from './services/card/card.service';
import { CartSourceMockService } from './services/cart/cart-source-mock.service';
import { CartSourceService } from './services/cart/cart-source.service';
import { CartStoreService } from './services/cart/cart-store.service';
import { CartService } from './services/cart/cart.service';
import { ConfigService } from './services/config/config.service';
import { CoreService } from './services/core/core.service';
import { CustomerSourceMockService } from './services/customer/customer-source-mock.service';
import { CustomerSourceService } from './services/customer/customer-source.service';
import { CustomerService } from './services/customer/customer.service';
import { EventsSourceMockService } from './services/event/events-source-mock.service';
import { EventsSourceService } from './services/event/events-source.service';
import { EventsService } from './services/event/events.service';
import { IamSourceMockService } from './services/iam/iam-source-mock.service';
import { IamSourceService } from './services/iam/iam-source.service';
import { IamService } from './services/iam/iam.service';
import { LazyLoaderService } from './services/lazy-loader/lazy-loader.service';
import { MediaSourceMockService } from './services/media/media-source-mock.service';
import { MediaSourceService } from './services/media/media-source.service';
import { MediaService } from './services/media/media.service';
import { PartnerSourceMockService } from './services/partner/partner-source-mock.service';
import { PartnerSourceService } from './services/partner/partner-source.service';
import { PartnerService } from './services/partner/partner.service';
import { PaymentSourceMockService } from './services/payment/payment-source-mock.service';
import { PaymentSourceService } from './services/payment/payment-source.service';
import { PaymentService } from './services/payment/payment.service';
import { StoreService } from './services/store/store.service';
import { ThemeService } from './services/theme/theme.service';
import { VenueSourceMockService } from './services/venue/venue-source-mock.service';
import { VenueSourceService } from './services/venue/venue-source.service';
import { VenueService } from './services/venue/venue.service';

@NgModule({
  imports: [
    CommonModule,
    ScriptLoaderModule,
    HttpModule.forRoot({ serviceUrl: environment.serviceUrl }),
    TranslateModule.forRoot({ appVersion: environment.version }),
    PipeModule.forRoot(),
  ],
  providers: [
    AuthService,
    ErrorService,
    ErrorLoggerService,
    StoreService,
    ConfigService,
    LazyLoaderService,
    ThemeService,
    CoreService,
    CartGuard,
    CartStoreService,
    MediaService,
    {
      provide: IMediaSource,
      useClass: environment.mock || environment.modules.core.media.mock ? MediaSourceMockService : MediaSourceService,
    },
    IamService,
    {
      provide: IIamSource,
      useClass: environment.mock || environment.modules.core.iam.mock ? IamSourceMockService : IamSourceService,
    },
    EventsService,
    {
      provide: IEventsSource,
      useClass: environment.mock || environment.modules.core.event.mock ? EventsSourceMockService : EventsSourceService,
    },
    VenueService,
    {
      provide: IVenueSource,
      useClass: environment.mock || environment.modules.core.venue.mock ? VenueSourceMockService : VenueSourceService,
    },
    CartService,
    {
      provide: ICartSource,
      useClass: environment.mock || environment.modules.core.cart.mock ? CartSourceMockService : CartSourceService,
    },
    CustomerService,
    {
      provide: ICustomerSource,
      useClass: environment.mock || environment.modules.core.customer.mock ? CustomerSourceMockService : CustomerSourceService,
    },
    PaymentService,
    {
      provide: IPaymentSource,
      useClass: environment.mock || environment.modules.core.payment.mock ? PaymentSourceMockService : PaymentSourceService,
    },
    PartnerService,
    {
      provide: IPartnerSource,
      useClass: environment.mock || environment.modules.core.partner.mock ? PartnerSourceMockService : PartnerSourceService,
    },
    CardService,
    {
      provide: ICardSource,
      useClass: environment.mock || environment.modules.core.event.mock ? CardSourceMockService : CardSourceService,
    },
  ],
})
export class CoreModule {

  // Always instantiate core service and subscribe to resize
  constructor(private coreService: CoreService) {
    this.coreService.setViewHeight();
    this.coreService.subscribeToResize();
  }

}
